import { Box } from "rebass";
import { ThemeProvider } from "@emotion/react";

const theme = {
  breakpoints: [
    /* 
            Breakpoints:
                20em = 320px
                64em = 1024px
        */
    "20em",
    "64em",
  ],
};

const AlertBannerWrapper = ({ children, backgroundColor, visible, sx }) => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        pt={10}
        pb={[16, 10]}
        px={[40, 45]}
        sx={{
          width: "100%",
          position: "relative",
          ...sx,
        }}
        display={visible ? "block" : "none"}
        backgroundColor={backgroundColor ?? backgroundColor}
      >
        {" "}
        {children}{" "}
      </Box>
    </ThemeProvider>
  );
};

export default AlertBannerWrapper;
